import Vue from 'vue'
import Echo from 'laravel-echo'
import io from 'socket.io-client';
import token from '@/utils/storage/token'

window.io = io;